import { motion } from 'framer-motion';

interface SharedHeroProps {
    label: string;
    title: React.ReactNode;
    subtitle: string;
    image?: string;
}

const SharedHero = ({ label, title, subtitle, image }: SharedHeroProps) => {
    return (
        <div className="relative w-full font-jakarta flex flex-col items-center justify-start pt-32 pb-24 overflow-hidden" style={{ background: 'linear-gradient(to bottom, #0052D4, #4364F7, #6FB1FC)' }}>

            {/* Header Content */}
            <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <div className="inline-block relative px-8 py-3 mb-6">
                    {/* Dashed Border Box Simulation - White for contrast */}
                    <div className="absolute inset-0 border border-dashed border-white/40 rounded-lg pointer-events-none" />

                    {/* Corners Squares - White */}
                    <div className="absolute -top-1 -left-1 w-2 h-2 bg-white" />
                    <div className="absolute -top-1 -right-1 w-2 h-2 bg-white" />
                    <div className="absolute -bottom-1 -left-1 w-2 h-2 bg-white" />
                    <div className="absolute -bottom-1 -right-1 w-2 h-2 bg-white" />

                    <h1 className="font-syne font-bold text-lg md:text-xl text-white tracking-widest uppercase mb-0">
                        {label}
                    </h1>
                </div>

                <h1 className="font-syne font-bold text-4xl md:text-5xl lg:text-5xl text-white leading-[1.1] mb-6 tracking-tight drop-shadow-sm">
                    {title}
                </h1>

                {/* Subheading */}
                <p className="text-lg md:text-md text-blue-50 max-w-3xl mx-auto font-medium leading-relaxed drop-shadow-sm">
                    {subtitle}
                </p>

                {/* Hero Image */}
                {image && (
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2, duration: 0.8 }}
                        className="mt-16 rounded-2xl overflow-hidden shadow-2xl shadow-blue-900/40 border-4 border-white/20 mx-auto max-w-5xl"
                    >
                        <img src={image} alt="Hero Feature" className="w-full h-auto object-cover" />
                    </motion.div>
                )}
            </div>
        </div>
    );
};

export default SharedHero;
